/**
 * The personalization data type allows the differentiation between the types
 * of personalization data that is used.
 */
export enum PersonalizationDataType {
  Choice = 'choice',
  Product = 'product',
  Category = 'category'
}
